import React, { useMemo } from 'react';
import {
  getPaginationItems,
  PaginationItem as PaginationItemType,
} from './pagination-items';
import PaginationItem from './pagination-item';
import * as S from './styles';

type Props = {
  currentPage: number;
  totalPages: number;
  linkToPage: (page: number) => string;
  onClick?: (item: PaginationItemType) => void;
  alwaysShowStepButtons?: false;
};

const Pagination = ({
  currentPage,
  totalPages,
  linkToPage,
  onClick,
  alwaysShowStepButtons,
}: Props) => {
  const paginationItems = useMemo(
    () =>
      getPaginationItems(currentPage, totalPages, { alwaysShowStepButtons }),
    [currentPage, totalPages, alwaysShowStepButtons]
  );

  return (
    <S.Pagination data-test="Pagination">
      {paginationItems.map(item => (
        <S.PaginationListItem
          key={`${item.type}:${item.pageNumber}`}
          indicateOmittedPages={item.indicateOmittedPages}
          omitOnSmallDevices={item.omitOnSmallDevices}
        >
          <PaginationItem
            item={item}
            linkToPage={linkToPage}
            onClick={onClick}
          />
        </S.PaginationListItem>
      ))}
    </S.Pagination>
  );
};

export default Pagination;
